import { FunctionComponent, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import envConfig from '../../../src/config';

const getMaintenanceStrapi = () => {
  return fetch(`${envConfig.CMS_API_URL}/maintenance`)
    .then((res) => res.json())
    .then((data) => data);
};

const MaintenanceContainer: FunctionComponent<{ children: any }> = ({ children }) => {
  const [myValue, setMyValue] = useState({ text: '', active: false });
  const routerLocation = useLocation();

  useEffect(() => {
    getMaintenanceStrapi().then((data) => {
      setMyValue(data);
    });
  }, [routerLocation.pathname]);

  if (myValue.active) {
    // if (true) {
    return (
      <>
        <HeaderStyled>
          <div>
            <img className="logo" src="/images/logo_footer.png" />
            <H3Styled>Site em Manutenção</H3Styled>
          </div>
        </HeaderStyled>
        <MainStyled>
          <MaintenanceText>{myValue.text}</MaintenanceText>
          <div>
            <p className="info">Para maiores informações entre em contato:</p>
            <p className="contact">Telefone/Whatsapp</p>
            <PhoneStyled>(21) 4040-4840</PhoneStyled>
          </div>
        </MainStyled>
        <FooterStyled>
          <p>HTK LENTES OFTALMICAS SA</p>
          <p>Rua São Luiz Gonzaga,867 - São Cristóvão,</p>
          <p>Rio de Janeiro, RJ - CEP 20910-061 - Brasil</p>
        </FooterStyled>
      </>
    );
  }

  return children;
};

const HeaderStyled = styled.header`
  width: 100%;
  height: 476px;
  left: 0px;
  top: 0px;
  background: linear-gradient(90deg, #6e80db 0%, #6bbfd0 100%);
  justify-content: center;
  align-items: center;
  display: flex;
  color: white;
  text-align: center;

  & .logo {
    width: 316px;
    height: auto;
  }
`;

const MaintenanceText = styled.p`
  margin: 40px 0;
  font-size: 2rem;
`;

const H3Styled = styled.h3`
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 40px;
`;

const MainStyled = styled.main`
  text-align: center;
  font-weight: 400;

  & .info,
  & .contact {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 1rem;
  }
`;

const PhoneStyled = styled.h2`
  background: -webkit-linear-gradient(left, #3b94df, #cf88ed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const FooterStyled = styled.footer`
  text-align: center;
  font-weight: 400;
  margin-top: 50px;
`;

export { MaintenanceContainer };
